module.exports = __webpack_public_path__ + "img/logo-1.65ae03aa.png";